<template>
  <section>
    <v-row>
      <v-col
        cols="12"
        sm="3"
      >
        <v-select
          :items="$store.state.Rooms.rooms"
          label="Выберите комнату"
          v-model="nameWindow1"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-text-field
          label="Введите ширину стены, мм"
          type="number"
          v-model.number="widthWindow1"
          @change="costStep1Window1Method()"
          />
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-text-field
          label="Введите высоту стены, мм"
          type="number"
          v-model.number="heightWindow1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="50%" src="/img/window.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="windowTypeSelected1" @change="costStep1Window1Method()">
            <v-radio
              label="Простое окно"
              value="Простое окно"
            />
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="50%" src="/img/window2.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="windowTypeSelected1" @change="costStep1Window1Method()">
            <v-radio
              label="Балконный блок (окно и дверь)"
              value="Балконный блок (окно и дверь)"
            />
            </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="50%" src="/img/window3.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="windowTypeSelected1" @change="costStep1Window1Method()">
            <v-radio
              label="Эркерное окно"
              value="Эркерное окно"
            />
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        class="summaryCol"
        cols="12"
        sm="3"
      >
        <h2>Окно №1: {{ nameWindow1 }}</h2>
        <h3 class="pt-5">Вы выбрали:</h3>
        <ul class="pt-5">
          <li v-if="windowTypeSelected1"><span><b>Тип окна:</b></span> {{ windowTypeSelected1 }}</li>
          <li v-if="widthWindow1 && heightWindow1"><span><b>Размер стены:</b></span> <span v-if="widthWindow1 && heightWindow1">{{ widthWindow1 }}</span><span v-if="widthWindow1 && heightWindow1">*</span>{{ heightWindow1 }}</li>
        </ul>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'TypeWindow1',
  computed: {
    nameWindow1: {
      get () {
        return this.$store.state.Window1.nameWindow1
      },
      set (value) {
        this.$store.commit('updateNameWindow1', value)
      }
    },
    widthWindow1: {
      get () {
        return this.$store.state.Window1.widthWindow1
      },
      set (value) {
        this.$store.commit('updateWidthWindow1', value)
      }
    },
    heightWindow1: {
      get () {
        return this.$store.state.Window1.heightWindow1
      },
      set (value) {
        this.$store.commit('updateHeightWindow1', value)
      }
    },
    windowTypeSelected1: {
      get () {
        return this.$store.state.Window1.windowTypeSelected1
      },
      set (value) {
        this.$store.commit('windowTypeSelected1', value)
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    costStep1Window1Method () {
      this.$store.commit('calcCostWindow1')
    }
  }
}
</script>

<style>

</style>
